import { App } from 'vue';
import { formatNumber, formatCurrency, formatPercent } from '../utils/formatters';

export default {
  install: (app: App) => {
    // 注册全局方法
    app.config.globalProperties.$formatNumber = formatNumber;
    app.config.globalProperties.$formatCurrency = formatCurrency;
    app.config.globalProperties.$formatPercent = formatPercent;
    
    // 注册全局过滤器（Vue 3 不再支持过滤器，但我们可以使用全局方法代替）
    app.config.globalProperties.$filters = {
      formatNumber,
      formatCurrency,
      formatPercent
    };
  }
};
